module.exports = __webpack_public_path__ + "img/franchising_terms_icon2.d54c0577.svg";